import { render } from "./no-record-found.vue?vue&type=template&id=2bfddee0"
import script from "./no-record-found.vue?vue&type=script&lang=js"
export * from "./no-record-found.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__